export const lineHeight = 'normal';
